import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from "axios";
import { baseUrl } from './config';
import Cookies from 'js-cookie';

export const MemberInsert = createAsyncThunk(
    '/MemberInsert',
    async (data, { rejectWithValue }) => {
        let url = baseUrl+'contactRequest';
        const token=Cookies.get("token");
      try {
        const response = (await axios.post(url,data,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        })).data

        if(response.status === "success" || response.status === "error"){
            return response;
        }else{
          return rejectWithValue(response || { status: "error", message: "Failed to add member" });
        }
      } catch (err) {
        return rejectWithValue(err?.response?.data || { status: "error", message: err?.message || "Failed to add member" });
      }
    },
  );

  export const MemberUpdate = createAsyncThunk(
    '/MemberUpdate',
    async (data, { rejectWithValue }) => {
        let url = baseUrl+'contactUpdate';
        const token=Cookies.get("token");
      try {
        const response = (await axios.post(url,data,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        })).data

        if(response.status === "success" || response.status === "error"){
            return response;
        }else{
          return rejectWithValue(response || { status: "error", message: "Failed to update member" });
        }
      } catch (err) {
        return rejectWithValue(err?.response?.data || { status: "error", message: err?.message || "Failed to update member" });
      }
    },
  );

  export const GetMembers = createAsyncThunk(
    '/GetMembers',
    async (data, { rejectWithValue }) => {
        let url = baseUrl+'getcontacts';
        const token=Cookies.get("token");
      try {
        const response = (await axios.post(url,data,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        })).data

        if(response.status == "success" || response.status === "error"){
            return response;
        }else{
          return rejectWithValue(response || { status: "error", message: "Failed to fetch members" });
        }
      } catch (err) {
        return rejectWithValue(err?.response?.data || { status: "error", message: err?.message || "Failed to fetch members" });
      }
    },
  );

  export const DeletetMembers = createAsyncThunk(
    '/DeletetMembers',
    async (data, { rejectWithValue }) => {
        let url = baseUrl+'deleteContact';
        const token=Cookies.get("token");
      try {
        const response = (await axios.post(url,data,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        })).data

        if(response.status == "success" || response.status === "error"){
            return response;
        }else{
          return rejectWithValue(response || { status: "error", message: "Failed to delete member" });
        }
      } catch (err) {
        return rejectWithValue(err?.response?.data || { status: "error", message: err?.message || "Failed to delete member" });
      }
    },
  );

  export const IsCompanyExist = createAsyncThunk(
    '/isCompanyExist',
    async(data, {rejectWithValue}) => {
      let url = baseUrl + 'isCompanyExist';
      let token = Cookies.get("token");

      try{
        const response = (await axios.post(url, data, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })).data;
        if (response.status === "error") {
          return Promise.reject(response);
        }

        return Promise.resolve(response);
      }catch(err){
        return rejectWithValue(err.response?.message || { status: false, message: "API error" });
      }
    }
  )


